import React from "react";
import { twMerge } from "tailwind-merge";
import { Sizes } from "UIKit/types";

export enum PillSizes {
  EXTRA_SMALL = Sizes.EXTRA_SMALL,
  SMALL = Sizes.SMALL,
  MEDIUM = Sizes.MEDIUM,
}

export interface PillProps {
  value?: string;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  size?: Sizes;
  icon?: React.ReactNode;
}

export const Pill = ({
  value,
  disabled,
  className = "",
  onClick,
  size = Sizes.MEDIUM,
  icon,
}: PillProps) => {
  const pillClass = {
    [Sizes.SMALL]: "p-1.5",
    [Sizes.MEDIUM]: "p-2.5",
    [Sizes.EXTRA_SMALL]: "h-8",
  };

  return (
    <span
      data-testid="pill"
      className={twMerge(
        `flex items-center space-x-2 justify-center rounded-2xl ${pillClass[size]}`,
        className,
      )}
      onClick={() => !disabled && onClick && onClick()}
    >
      {icon && <div>{icon}</div>}
      <div>{value}</div>
    </span>
  );
};
